import { Link } from 'react-router-dom';
import Button from '../common/Button';
import JobContentBlocks from './JobContentBlocks';
import JobMetadataGrid from './JobMetadataGrid';

function JobAccordionCard({ acceptingApplications = true, isOpen, job, onToggle }) {
  const detailPath = `/jobs/${job.category.slug}/${job.slug}`;

  return (
    <article className={`job-accordion-card ${isOpen ? 'is-open' : ''}`}>
      <div className="job-accordion-card__top">
        <div>
          <Link onClick={(event) => event.stopPropagation()} to={detailPath}>
            {job.title}
          </Link>
          {job.shortSummary ? <small>{job.shortSummary}</small> : null}
        </div>
      </div>

      <JobMetadataGrid heading="JOB BRIEF INFO" metadata={job.metadata} />

      <div className="job-accordion-card__body" hidden={!isOpen}>
        <JobContentBlocks blocks={job.contentBlocks} html={job.contentHtml} />
      </div>

      <div className="job-accordion-card__footer">
        <Button
          aria-expanded={isOpen}
          className="job-accordion-card__details"
          onClick={onToggle}
          variant="secondary"
        >
          <span>{isOpen ? 'Hide Details' : 'View Details'}</span>
        </Button>
        {acceptingApplications ? (
          <Button className="job-accordion-card__apply" to="/apply">
            Apply now
          </Button>
        ) : (
          <Button className="job-accordion-card__apply" disabled>
            Hiring Closed
          </Button>
        )}
      </div>
    </article>
  );
}

export default JobAccordionCard;
